import axios from 'axios';

const getBaseUrl = () => process.env.REACT_APP_SERVER_URL;

const getHeaders = (isMultipart = false) => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      ...(isMultipart
        ? { 'Content-Type': 'multipart/form-data' }
        : { 'Content-Type': 'application/json' })
    }
  };
};

export const getDocumentTypes = async (includeInactive = false) => {
  const url = `${getBaseUrl()}/patient-documents/types${
    includeInactive ? '?include_inactive=1' : ''
  }`;
  const response = await axios.get(url, getHeaders());
  return response.data;
};

export const getDocumentType = async id => {
  const url = `${getBaseUrl()}/patient-documents/types/${id}`;
  const response = await axios.get(url, getHeaders());
  return response.data;
};

export const createDocumentType = async typeData => {
  const url = `${getBaseUrl()}/patient-documents/types`;
  const response = await axios.post(url, typeData, getHeaders());
  return response.data;
};

export const updateDocumentType = async (id, typeData) => {
  const url = `${getBaseUrl()}/patient-documents/types/${id}`;
  const response = await axios.put(url, typeData, getHeaders());
  return response.data;
};

export const toggleDocumentTypeStatus = async (id, isActive) => {
  const url = `${getBaseUrl()}/patient-documents/types/${id}/toggle-status`;
  const response = await axios.post(url, { is_active: isActive }, getHeaders());
  return response.data;
};

export const toggleGroupOptout = async (id, groupId, enabled) => {
  const url = `${getBaseUrl()}/patient-documents/types/${id}/group-optout`;
  const response = await axios.post(
    url,
    { group_id: groupId, enabled },
    getHeaders()
  );
  return response.data;
};

export const getGroupOptouts = async id => {
  const url = `${getBaseUrl()}/patient-documents/types/${id}/group-optouts`;
  const response = await axios.get(url, getHeaders());
  return response.data;
};

export const getAvailableTypes = async () => {
  const url = `${getBaseUrl()}/patient-documents/available-types`;
  const response = await axios.get(url, getHeaders());
  return response.data;
};

export const getPatientDocuments = async patientId => {
  let url = `${getBaseUrl()}/patient-documents/patient/${patientId}`;
  const response = await axios.get(url, getHeaders());
  return response.data;
};

export const getDocumentDetail = async id => {
  const url = `${getBaseUrl()}/patient-documents/${id}`;
  const response = await axios.get(url, getHeaders());
  return response.data;
};

export const createDocument = async formData => {
  const url = `${getBaseUrl()}/patient-documents`;
  const response = await axios.post(url, formData, getHeaders(true));
  return response.data;
};

export const updateDocument = async (id, docData) => {
  const url = `${getBaseUrl()}/patient-documents/${id}`;
  const response = await axios.put(
    url,
    docData,
    getHeaders(docData instanceof FormData)
  );
  return response.data;
};

export const addDocumentFiles = async (id, formData) => {
  const url = `${getBaseUrl()}/patient-documents/${id}/files`;
  const response = await axios.post(url, formData, getHeaders(true));
  return response.data;
};

export const deleteDocumentFile = async (id, fileId) => {
  const url = `${getBaseUrl()}/patient-documents/${id}/files/${fileId}/delete`;
  const response = await axios.post(url, {}, getHeaders());
  return response.data;
};

export const deleteDocument = async id => {
  const url = `${getBaseUrl()}/patient-documents/${id}/delete`;
  const response = await axios.post(url, {}, getHeaders());
  return response.data;
};

export const getFileDownloadUrl = fileId => {
  const token = localStorage.getItem('accessToken');
  return `${getBaseUrl()}/patient-documents/file/${fileId}?token=${token}`;
};
